import { put, call, select, takeLatest } from "redux-saga/effects";
import { fetchDowntimeList } from "Services/api/downtime";

import { format } from "date-fns";

import { nodes } from "Constants/filters";

import { filterSelectors, filterActionTypes } from "..";

/********** ACTION_TYPES **********/
export const actionTypes = {
  fetchData: "downtimeList/INITIATE_FETCH_DATA",
  fetchDataFailed: "downtimeList/FETCH_DATA_FAILED",
  fetchDataFulfilled: "downtimeList/FETCH_DATA_FULFILLED",
};

/********** REDUCER **********/
const initialState = {
  fetching: false,
  fetched: false,
  data: {},
  errMsg: null,
};

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case filterActionTypes.updateDowntimeFilter:
    case actionTypes.fetchData: {
      return {
        ...state,
        fetching: true,
      };
    }
    case actionTypes.fetchDataFailed: {
      return {
        ...state,
        fetching: false,
        fetched: false,
        errMsg: action.payload,
      };
    }
    case actionTypes.fetchDataFulfilled: {
      if (action.payload.infiniteLoading) {
        action.payload.data.data = [
          ...(state?.data?.data || []),
          ...(action?.payload?.data?.data || []),
        ];
      }
      return {
        ...state,
        fetching: false,
        fetched: true,
        data: action.payload.data,
        errMsg: null,
      };
    }
    default: {
      return state;
    }
  }
};

/********** SELECTORS **********/
export const selectors = {
  getDowntimeList: (state) => state.downtimeList?.data || {},
  isFetching: (state) => state.downtimeList?.fetching,
  isFetched: (state) => state?.downtimeList?.fetched,
  getErrorMsg: (state) => state.downtimeList?.errMsg,
};

/********** ACTION_CREATORS **********/
export const actions = {
  fetchData: (data) => ({
    type: actionTypes.fetchData,
    payload: data,
  }),
  fetchDataFailed: (data) => ({
    type: actionTypes.fetchDataFailed,
    payload: data,
  }),
  fetchDataFulfilled: (data, infiniteLoading) => ({
    type: actionTypes.fetchDataFulfilled,
    payload: { data, infiniteLoading },
  }),
};

/********** WORKERS **********/
function* fetchDataWorker(data) {
  if (data?.payload?.noNetworkCall) return;
  try {
    const state = yield select();
    const {
      dateFrom,
      dateTo,
      startTime,
      endTime,
      pageOffset,
      pageSize,
      orderBy,
      order,
      isCurrentlyDown,
      filters,
    } = filterSelectors.getFilters(state, nodes.downtimeList);
    const params = {
      dateFrom: `${format(dateFrom, "yyyy-MM-dd")} ${
        startTime ? startTime : "00:00:00"
      }`,
      dateTo: `${format(dateTo, "yyyy-MM-dd")} ${
        endTime ? endTime : "23:59:59"
      }`,
      pageOffset,
      pageSize,
      orderBy,
      order,
      ...filters,
      isCurrentlyDown,
    };
    const response = yield call(
      fetchDowntimeList,
      isCurrentlyDown ? { isCurrentlyDown, pageSize: 50 } : params
    );

    if (response.status == 200) {
      yield put(
        actions.fetchDataFulfilled(
          response?.data?.result,
          data?.payload?.infiniteLoading
        )
      );
    }
  } catch (err) {
    const errMsg = yield err?.response?.data?.error || "Something went wrong";
    yield put(actions.fetchDataFailed(errMsg));
  }
}

/********** SAGAS **********/
export function* saga() {
  yield takeLatest(actionTypes.fetchData, fetchDataWorker);
  yield takeLatest(filterActionTypes.updateDowntimeFilter, fetchDataWorker);
}
